export default __webpack_public_path__ + "static/media/Group 3380@2x.64daea8d.png";